export default __webpack_public_path__ + "static/media/person_add.56c19817.png";